/* FAQ アコーディオン */
/*===========================*/
document.addEventListener('DOMContentLoaded', function(){
    gsap.set(document.querySelectorAll('.accordion__item-body01'),{height:'auto'});//1つ目だけ開いておく
    let toggleButton = document.querySelectorAll('.accordion__item-head');
    for (let i = 0; i < toggleButton.length; i++) {
        toggleButton[i].addEventListener('click',function(){
            let target = this.nextElementSibling;
            let target2 = this;
            const result = target.classList.contains('is-active');
            const question = target2.classList.contains('is-active');
            
            if (result) {
                // 閉じる
                target.classList.remove('is-active');
                
                gsap.to(target,{
                    height: 0,
                    duration:0.5,
                    ease: "power2.inOut",
                    
                });
            }else{
                // 開く
                target.classList.add('is-active');
                gsap.to(target,{
                    height:'auto',
                    duration:0.5,
                    ease: "power2.inOut",
                    
                });
            }

            if (question) {
                // 閉じる
                target2.classList.remove('is-active');
            }else{
                // 開く
                target2.classList.add('is-active');
            }
            
        })
    }
}, false);